(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"]) return;
  try {
    
const slider = document.getElementById("sliderTrack");
const videos = slider.querySelectorAll("video");
let index = 0;

function updateSlider() {
  slider.style.transform = `translateX(-${index * slider.clientWidth}px)`;
  videos.forEach(v => v.pause());
  videos[index].currentTime = 0;
  videos[index].play();
}

document.getElementById("nextVideo").onclick = () => {
  index = (index + 1) % videos.length;
  updateSlider();
}

document.getElementById("prevVideo").onclick = () => {
  index = (index - 1 + videos.length) % videos.length;
  updateSlider();
}

// Auto loop every 8 seconds
setInterval(() => {
  index = (index + 1) % videos.length;
  updateSlider();
}, 8000);

  } catch(e) { console.error(e); }
})();
})();
